export const NON_PUZZLE_END_REASONS = Object.freeze([
  "puzzle_turn_limit_reached",
  "puzzle_solve_time_expired",
]);

const toNormalizedString = (value) => String(value || "").trim().toLowerCase();

export const isPuzzleOrFreeBoxMode = (mode, isPuzzleMode = false) =>
  Boolean(isPuzzleMode) || toNormalizedString(mode) === "freebox";

const isPuzzleFailureReason = (endReason) => {
  const normalizedReason = toNormalizedString(endReason);
  return NON_PUZZLE_END_REASONS.includes(normalizedReason);
};

export const shouldFailPuzzleEndAsOpponentWon = ({
  mode,
  isPuzzleMode,
  normalizedEndReason,
  iAmParticipant,
  winnerIds = [],
  iAmOneOfWinners,
  winnerPlayerIndex,
  localPlayerIndex,
  localPlayerIndexKnown,
}) => {
  if (!isPuzzleOrFreeBoxMode(mode, isPuzzleMode)) return false;
  if (isPuzzleFailureReason(normalizedEndReason)) return false;

  const hasWinnerIds = Array.isArray(winnerIds) && winnerIds.length > 0;
  if (hasWinnerIds) {
    return !Boolean(iAmOneOfWinners);
  }

  if (
    Number.isFinite(winnerPlayerIndex) &&
    Number.isFinite(localPlayerIndex) &&
    winnerPlayerIndex != null &&
    localPlayerIndexKnown
  ) {
    return Math.floor(winnerPlayerIndex) !== Math.floor(localPlayerIndex);
  }

  // En eventos de puzzle/freebox puede venir sin datos de ganador explícitos.
  // Para el fin por bloqueos (winner_reached_goal), se asume que si el local
  // está participando y no viene ganador explícito, el turno debe terminar como
  // derrota del local (regla de bloqueo de bloques dominados).
  if (iAmParticipant && !iAmOneOfWinners) {
    return true;
  }

  return false;
};
